let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8BJYY")).then(() => parcelRequire('lHApX'));